export default [
    {
        path: '/comissao-membros/listar/:id',
        view: 'comissao-membros/Index',
        name: 'Membros da Comissão',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Comissões',
                disabled: false,
                exact: true,
                to: '/comissoes',
            },
            {
                text: 'Membros da Comissão',
                disabled: true,
                exact: true,
                to: '/comissao-membros/listar/:id',
            }
        ],
    },
    {
        path: '/comissao-membros/novo/:idComissao',
        view: 'comissao-membros/New',
        name: 'Cadastrar Membros da Comissão',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Comissões',
                disabled: false,
                exact: true,
                to: '/comissoes',
            },
            {
                text: 'Membros da Comissão',
                disabled: true,
                exact: true,
                to: '/comissao-membros/listar/:id',
            },
            {
                text: 'Novo',
                disabled: true,
                exact: true,
                to: '/comissao-membros/novo/:idComissao',
            }
        ],
    },
    {
        path: '/comissao-membros/visualizar/:id',
        view: 'comissao-membros/View',
        name: 'Visualização de Membro da Comissão',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Comissões',
                disabled: false,
                exact: true,
                to: '/comissoes',
            },
            {
                text: 'Membros da Comissão',
                disabled: true,
                exact: true,
                to: '/comissao-membros/listar/:id',
            },
            {
                text: 'Visualização',
                disabled: true,
                exact: true,
                to: '/comissao-membros/visualizar/:id',
            }
        ],
    },
    {
        path: '/comissao-membros/editar/:id',
        view: 'comissao-membros/Edit',
        name: 'Edição de Membro da Comissão',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Comissões',
                disabled: false,
                exact: true,
                to: '/comissoes',
            },
            {
                text: 'Membros da Comissão',
                disabled: true,
                exact: true,
                to: '/comissao-membros/listar/:id',
            },
            {
                text: 'Edição',
                disabled: true,
                exact: true,
                to: '/comissao-membros/editar/:id',
            }
        ],
    },
    {
        path: '/comissao-membros/excluir',
        permissions: ['ADMINISTRADOR', 'GESTOR']
    },
];
